import DeleteButton from 'CMFW/button/DeleteButton';
import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import MemoryMeansTemplateSelect from 'components/selects/MemoryMeansTemplateSelect';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import {
  ContainerLeft,
  ContainerLeftFooter,
  ContainerRight,
  EditorGapGreedy,
  EditorRow,
} from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import React, { useMemo } from 'react';
import MemoryMeansTemplateSetsModel from 'models/MemoryMeansTemplateSetsModel';

const MeansTemplateSets: React.FC = () => {
  const forceRender = useForceRender();
  const model = useMemo(() => new MemoryMeansTemplateSetsModel({ render: forceRender }), [forceRender]);

  return (
    <ModuleContext.Provider value={model}>
      <Split widthLeft={520}>
        <ContainerLeft>
          <Grid />
          <ContainerLeftFooter>
            <ReloadButton />
            <NewButton />
          </ContainerLeftFooter>
        </ContainerLeft>
        <ContainerRight>
          <ItemLayout>
            <EditorRow>
              <MemoryMeansTemplateSelect keyName={'em1_bank_item_id'} label={'EM1 Paragraph Bank item'} emCount={1} />
            </EditorRow>
            <EditorRow>
              <MemoryMeansTemplateSelect keyName={'em2_bank_item_id'} label={'EM2 Paragraph Bank item'} emCount={2} />
            </EditorRow>
            <EditorRow>
              <MemoryMeansTemplateSelect keyName={'em3_bank_item_id'} label={'EM3 Paragraph Bank item'} emCount={3} />
            </EditorRow>
            <EditorRow>
              <DeleteButton />
              <SaveButton />
            </EditorRow>
            <EditorGapGreedy />
          </ItemLayout>
          <LoadingItem />
        </ContainerRight>
      </Split>
    </ModuleContext.Provider>
  );
};

export default MeansTemplateSets;
